import { useRef, forwardRef, ChangeEvent } from "react";
import { mergeRefs } from "../../../common/utils/merge-refs";
import { IconPressEvent, InputRef } from "../../../input/types";
import { Input } from "../../../input";
import { SearchProps } from "./types";

export const Search = forwardRef<InputRef, SearchProps>(
  (
    {
      id,
      hint,
      error,
      label,
      value,
      disabled,
      clearable,
      dataTestId,
      onFocus,
      onClear,
      onChange,
    },
    forwardedRef
  ) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value);
    };

    const handleClear = (event: IconPressEvent) => {
      onChange("");
      onClear?.(event);
    };

    return (
      <Input
        id={id}
        hint={hint}
        error={error}
        clearable={clearable}
        label={label}
        value={value}
        ref={mergeRefs(forwardedRef, inputRef)}
        disabled={disabled}
        autoComplete="off"
        dataTestId={dataTestId}
        onFocus={onFocus}
        onClear={handleClear}
        onChange={handleChange}
      />
    );
  }
);

Search.displayName = "Search";
